import { Link } from "react-router-dom";
import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  ...theme.paddings(30, 0),
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: 30,

  [theme.down("md")]: {
    flexDirection: "column",
    gap: 20,
    alignItems: "center",
    justifyContent: "center",
  },
}));

export const LinksBlock = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)",
  gap: 20,
  flexGrow: 3,

  // на планшете четыре колонки уже не помещаются
  [theme.upDown("sm", "md")]: {
    gridTemplateColumns: "1fr 1fr",
  },

  [theme.upDown("xs", "sm")]: {
    flexGrow: 1,
    gridTemplateColumns: "1fr",
    textAlign: "center",
  },

  [theme.down("md")]: {
    gap: 20,
  },

  [theme.down("xs")]: {
    flexGrow: 1,
    gridTemplateColumns: "1fr",
    textAlign: "center",
  },
}));

export const LegalInformation = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",

  "& > h2": {
    fontSize: 20,
    marginBottom: 10,
  },
}));

export const Deals = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",

  "& > h2": {
    fontSize: 20,
    marginBottom: 10,
  },
}));

export const About = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",

  "& > h2": {
    fontSize: 20,
    marginBottom: 10,
  },
}));

export const Opportunities = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",

  "& > h2": {
    fontSize: 20,
    marginBottom: 10,
  },
}));

export const Contacts = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",

  "& > h2": {
    fontSize: 20,
    marginBottom: 10,
  },
}));

export const ContactList = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: 12,
  marginTop: 4,
}));

export const ContactItem = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  gap: 10,
  fontSize: 15,
  lineHeight: "22px",

  "& > svg": {
    flexShrink: 0,
    width: 18,
    height: 18,
    marginTop: 2,
    color: theme.palette.footer?.textMuted || "#aaa",
  },

  [theme.upDown("xs", "sm")]: {
    justifyContent: "center",
    textAlign: "left",
  },

  [theme.down("xs")]: {
    justifyContent: "center",
    textAlign: "left",
  },
}));

export const ContactLink = styled("a")(({ theme }) => ({
  display: "block",
  fontSize: 15,
  lineHeight: "22px",
  transition: "color .3s ease-in-out",
  whiteSpace: "nowrap",

  "&:hover": {
    color: theme.palette.border.light,
  },
}));

export const ContactText = styled("span")(({ theme }) => ({
  fontSize: 15,
  lineHeight: "22px",
  color: theme.palette.footer?.textMuted || "#aaa",
}));

export const LinkItem = styled(props => (
  <div>
    <Link {...props} />
  </div>
))(({ theme }) => ({
  fontSize: 15,
  lineHeight: "30px",
  transition: "color .3s ease-in-out",

  "&: hover": {
    color: theme.palette.border.light,
  },
}));

export const SocialsLink = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  marginTop: 10,
  gap: 15,

  "& > firstChild": {
    marginLeft: "-5px",
  },

  [theme.down("sm")]: {
    justifyContent: "center",
  },
}));

export const Socials = styled("img")(({ theme }) => ({
  width: "40px",
  height: "40px",
}));

export const LogosBlock = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 10,
  flexGrow: 1,

  [theme.down("sm")]: {
    flexGrow: 1,
    flexWrap: "wrap",
    justifyContent: "center",
  },

  "& > div": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

export const PaymentsLogo = styled("img")(({ theme }) => ({
  width: "100%",
  maxWidth: 150,
  height: "auto",
}));

export const IataLogo = styled("img")(({ theme }) => ({
  marginTop: -8,
  width: 85,
  height: 28,
}));

export const TkpLogo = styled("img")(({ theme }) => ({
  width: 71,
  height: 39,
}));

export const CopyRight = styled("p")(({ theme }) => ({
  marginTop: 10,
  fontSize: 16,
  color: theme.palette.white,
  lineHeight: "17px",
  textAlign: "center",
}));

export const CardLogosRow = styled("div")(({ theme }) => ({
  display: "flex",
  gap: "8px",
  alignItems: "center",
  flexWrap: "wrap",
  justifyContent: "center",
}));

export const CardLogo = styled("img")(({ theme }) => ({
  height: "28px",
  objectFit: "contain",
}));

export const CompanyInfoRow = styled("p")(({ theme }) => ({
  fontSize: 12,
  textAlign: "center",
  color: theme.palette.footer?.textMuted || "#aaa",
  padding: "12px 16px",
  borderTop: `1px solid ${theme.palette.footer?.border || "rgba(255,255,255,0.1)"}`,
  margin: 0,
  lineHeight: 1.6,
}));

export const DeveloperLink = styled("a")(({ theme }) => ({
  color: "inherit",
  textDecoration: "none",
  "&:hover": {
    textDecoration: "underline",
  },
}));
